<template>
  <section class="only-desktop my-10 w-full">
    <div
      class="w-full flex gap-x-[53px] py-[11px] rounded-[5px] px-[20px] border border-zt-light/[35] flex-row shadow-zt">
      <div class="w-3/5 flex justify-center items-center">
         <span class="text-center font-medium text-white text-[16px] leading-normal">
           <span v-html="code_desc"/>
        </span>
      </div>
      <div class="w-2/5 flex items-center justify-center">
        <a v-bind:href="promoLink" class="no-default-style ">
          <button
            class="py-3 uppercase px-[23px] zt-hover w-[241px] bg-zt-red rounded-[5px] text-[14px] font-semibold text-white">Odbierz kod promocyjny</button>
        </a>
      </div>
    </div>
    <div class="w-full min-w-[91px] gap-x-1 flex mt-[14px]">
      <a v-bind:href="promoLink" class="no-default-style w-[126px] zt-hover bookie-ticket bg-center leading-[30px] bg-no-repeat "
         :style="`background-image: url('/wp-content/themes/zawodtyper/assets/images/bilety-buki/${bookie.toLowerCase()}.svg')`">
        <!--   bilety   -->
      </a>
      <div class="w-full flex items-center gap-x-[10px] flex-row text-white">
        <div
          class="w-1/2 text-[16px] bg-zt-light-bg border items-center border-zt-light/[35] flex px-[27px] py-[7px] rounded-[5px] justify-between flex-row">
          <div class="w-fit" v-if="!areFightersPresent">
            <span class="font-semibold">1</span>
          </div>
          <div v-if="areFightersPresent" class="text-center w-full text-[16px]">
            <span>{{ fighter_1 }}</span>
          </div>
          <div>
            <span class="font-medium">{{ odds_1 }}</span>
          </div>
        </div>
        <div
          class="w-1/2 text-[16px] bg-zt-light-bg border items-center border-zt-light/[35] flex px-[27px] py-[7px] rounded-[5px] justify-between flex-row">
          <div class="w-fit" v-if="!areFightersPresent">
            <span class="font-semibold">2</span>
          </div>
          <div v-if="areFightersPresent" class="text-center w-full">
            <span>{{ fighter_2 }}</span>
          </div>
          <div>
            <span class="font-medium">{{ odds_2 }}</span>
          </div>
        </div>
      </div>
    </div>
  </section>


  <section class="only-mobile my-10 w-full">
    <div
      class="w-full flex gap-x-[10px] py-[11px] justify-between rounded-[5px] px-[10px] border border-zt-light/[35] flex-row shadow-zt">
      <div class="w-4/6 flex justify-center items-center">
        <span class="text-center text-white text-[14px] font-[500] leading-[21px]">
          <span v-html="code_desc"/>
        </span>
      </div>
      <div class="w-fit flex items-center">
        <a v-bind:href="promoLink" class="no-default-style ">
          <button
            class="py-3 uppercase px-[30px] text-[12px] zt-hover w-[145px] bg-zt-red rounded-[5px] font-semibold text-white">
            Odbierz kod promocyjny
          </button>
        </a>
      </div>
    </div>
    <div v-if="areFightersPresent" class="text-center pt-[6px] pb-[10px] text-[16px]">
      <span class="font-normal text-white">{{ fighter_1 }} - {{ fighter_2 }}</span>
    </div>
    <div class="w-full gap-x-[16px] flex" :class="areFightersPresent ? '' : 'mt-[28px]'">
      <a v-bind:href="promoLink" class="no-default-style w-[134px] zt-hover bookie-ticket bg-center bg-no-repeat"
           :style="`background-image: url('/wp-content/themes/zawodtyper/assets/images/bilety-buki/${bookie.toLowerCase()}.svg')`">
        <!--   bilety   -->
      </a>
      <div class="w-full flex items-center gap-x-[16px] flex-row text-white">
        <div
          class="w-1/2 text-[14px] bg-zt-light-bg border border-zt-light/[35] flex px-[27px] py-[7px] rounded-[5px] justify-between flex-row">
          <div class="w-fit">
            <span class="font-semibold">1</span>
          </div>
          <div>
            <span class="font-medium">{{ odds_1 }}</span>
          </div>
        </div>
        <div
          class="w-1/2 text-[14px] bg-zt-light-bg border border-zt-light/[35] px-[27px] py-[7px] rounded-[5px] flex gap-x-[27px] justify-between flex-row">
          <div class="w-fit">
            <span class="font-semibold">2</span>
          </div>
          <div>
            <span class="font-medium">{{ odds_2 }}</span>
          </div>
        </div>
      </div>
    </div>
  </section>


</template>

<script>
import utils_mixin from '../../mixins/utils_mixin';

export default {
  name: "BettingOdds",
  mixins: [utils_mixin],
  data() {
    return {
      bookie: this.$attrs.buk,
      odds_1: this.$attrs.kurs_1,
      odds_2: this.$attrs.kurs_2,
      fighter_1: this.$attrs.zaw_1,
      fighter_2: this.$attrs.zaw_2,
      code_desc: this.$attrs.opis_kodu,
    }
  },
  created() {
    this.code_desc = this.code_desc.replaceAll('[', '<span class="text-zt-red">');
    this.code_desc = this.code_desc.replaceAll(']', '</span>');
  },
  computed: {
    bookieTicket() {
      return this.bookie.toLowerCase();
    },
    areFightersPresent() {
      return this.fighter_1 && this.fighter_2;
    },
    promoLink() {
      return utils_mixin.methods.getBookiePromoLink(this.bookie);
    }
  }
}
</script>

<style scoped>
</style>